import { useFrame } from '@react-three/fiber';
import { useRef } from 'react';
import { Color, Fog, FogExp2, Group } from 'three';

import { CustomSky, CustomSkyRef } from '0_canvas/CustomSky/CustomSky';
import { SKY_STATE, useThreeStore } from 'state/threeStore';

import useMatrixUpdateHandler from 'hooks/useMatrixUpdateHandler';

export const SKY_BACKGROUNDS: Record<
  SKY_STATE,
  { sky: Color; horizon: Color } | null
> = {
  DAY: { sky: new Color(0x025ade), horizon: new Color(0xe1ebfa) },
  NIGHT: { sky: new Color(0x111015), horizon: new Color(0x111015) },
  TRANSPARENT: null,
  BLACK: { sky: new Color(0x111015), horizon: new Color(0x111015) },
  BUILDING: { sky: new Color(0x30a990), horizon: new Color(0x30a990) },
  CLOUDY: { sky: new Color(0xdae9dc), horizon: new Color(0xdae9dc) },
  STORMY: { sky: new Color(0xf9dbd3), horizon: new Color(0xeceffe) },
  FLOOD: { sky: new Color(0xe1ebfa), horizon: new Color(0xe1ebfa) },
  BUSHFIRE: { sky: new Color(0x111015), horizon: new Color(0x111015) },
};

const Sky = () => {
  const skyGroupRef = useRef<Group>(null!);
  const skyRef = useRef<CustomSkyRef>(null);

  useFrame(({ scene }) => {
    const { sky } = useThreeStore.getState();
    if (sky === 'BUILDING') return;

    // starsRef.current.visible = sky === 'NIGHT';
    skyGroupRef.current.visible = !['TRANSPARENT', 'NIGHT'].includes(sky);

    if (sky === 'CLOUDY') {
      scene.fog = new FogExp2(0xdae9dc, 0.002);
    } else if (sky === 'STORMY') {
      scene.fog = new FogExp2(0xeceffe, 0.0015);
    } else if (sky === 'BUSHFIRE') {
      scene.fog = new FogExp2(0x5f463d, 0.001);
    } else if (sky === 'FLOOD') {
      // scene.fog = new FogExp2(0x6d7676, 0.001);
    } else {
      scene.fog = new Fog(0xc4d4f1, 1200, 2000);
    }

    const currentSky = SKY_BACKGROUNDS[sky];
    if (!skyRef.current || !currentSky) return;
    skyRef.current.horizonColor = currentSky.horizon;
    skyRef.current.skyGroundColor = currentSky.sky;
  });

  useMatrixUpdateHandler(
    () => skyGroupRef.current.visible,
    skyGroupRef.current
  );

  return (
    <>
      <group ref={skyGroupRef}>
        <CustomSky
          horizonColor={new Color(0xccdffc)}
          skyGroundColor={new Color(0x025ade)}
          ref={skyRef}
        />
      </group>
    </>
  );
};

export default Sky;
